// 合同起草页面
<template>
  <div class="root-contrast">
    <!-- title -->
    <route-name propsRouteName="模板起草"></route-name>
    <!-- content 内容 -->
    <div class="content" v-loading="loading">
      <el-row :gutter="20">
        <el-col :span="5"
          ><div class="left">
            <div class="left-title">
              <!-- <el-tooltip
                class="item"
                effect="dark"
                content="AI智能合同"
                placement="top-start"
                ><div
                  :class="tabName === 'AIContracts' ? 'active' : ''"
                  @click="turnTab('AIContracts')"
                >
                  AI智能合同
                </div>
              </el-tooltip> -->
              <el-tooltip
                class="item"
                effect="dark"
                content="合同数据库"
                placement="top-start"
              >
                <div
                  :class="tabName === 'contracts' ? 'active' : ''"
                  @click="turnTab('contracts')"
                >
                  合同数据库
                </div>
              </el-tooltip>
            </div>
            <div class="items">
              <div
                class="left-btn"
                v-for="item of contractTypeList"
                :key="item._id"
                :style="{
                  color:
                    currtType && currtType._id === item._id ? '#F1461E' : '',
                }"
                @click="contractItem(item)"
              >
                {{ item.name }}
              </div>
            </div>
          </div></el-col
        >
        <el-col :span="19">
          <div class="right">
            <div style="text-align: right">
              <el-input
                placeholder="请输入文件名"
                v-model="searchVal"
                size="small"
                style="width: 360px; margin-bottom: 20px; margin-right: 20px"
              ></el-input>
              <el-button size="small" @click="searchData">查询</el-button>
              <el-button size="small" @click="rest">重置</el-button>
            </div>
            <div class="doc-list">
              <div
                class="doc-item"
                v-for="item of contractInfoList"
                :key="item.id"
              >
                <div class="doc-item-info">
                  <img src="/images/AISmart/icon/docIcon.png" alt="" />
                  <div class="info">
                    <p style="font-size: 0.87vw; font-weight: bolder">
                      {{ item.name }}
                    </p>
                    <span style="color: #777777; font-size: 12px">{{
                      item.howToUse
                    }}</span>
                  </div>
                </div>
                <span class="separate"></span>
                <div class="doc-action">
                  <div>
                    <el-button size="small" @click="draftUseTemp(item)"
                      >立即起草</el-button
                    >
                  </div>
                  <div
                    style="margin-top: 20px"
                    v-show="tabName === 'AIContracts'"
                  >
                    <el-button
                      size="small"
                      @click="
                        $router.push({
                          name: 'smartContract-proposed',
                          params: { name: item.name, tplCode: item.code },
                        })
                      "
                      >协同起草</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- 分页 -->
            <el-row class="pageation">
              <div style="padding: 30px 0" class="page-flex-end">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageModel.page"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="pageModel.pageSize"
                  layout="sizes, prev, pager, next, total"
                  :total="pageModel.total"
                />
                <el-go
                  :page-size="pageModel.pageSize"
                  :total="pageModel.total"
                  @current-change="handleCurrentChange"
                ></el-go>
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ElGo from "@/components/go/Go.vue";
import RouteName from "@/components/route-name";
// 接口
import { ApiMethods } from "../../../assets/js/http-serve/http-methods";
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  data () {
    return {
      tabName: "contracts",
      loading: false,
      smartAPI: ApiMethods.AIDocSmart,
      searchVal: "",
      pageModel: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      // 合同类型列表
      contractTypeList: [],
      currtType: "",
      // 某个合同类型下的合同
      contractInfoList: []
    };
  },
  // data end
  methods: {
    turnTab (tab) {
      if (this.tabName === tab) return;
      this.tabName = tab;
      this.searchVal = "";
      this.pageModel = {
        page: 1,
        pageSize: 10,
        total: 0
      };
      this.contractsQuery();
    },
    draftUseTemp (item) {
      const param = { fileName: item.name, tplId: item.code };
      this.smartAPI.draftUseTemp(param).then(res => {
        if (res.success) {
          this.$router.push({ path: "/smartDoc/docDraft/draftList" });
        } else {
          if (res.code == 10807) {
            this.buyDia();
            return;
          }
          this.$message.error(res.description);
        }
      });
    },
    // 点击了左边的某个合同类型
    contractItem (item) {
      this.currtType = item;
      this.searchData(item);
    },
    // 重置
    rest () {
      this.searchVal = "";
      this.pageModel.page = 1;
      this.searchData();
    },
    searchData (elem) {
      // if (!this.currtType && !elem) {
      //   return this.$message.error("请选择您需要查询的合同类型");
      // }
      const { page, pageSize } = this.pageModel;
      const param = {
        folder: elem && elem._id ? elem._id : this.currtType._id,
        keyword: this.searchVal,
        page,
        pageSize
      };
      if (this.tabName === "contracts") param.contractSource = 2;
      this.loading = true;
      this.smartAPI.categoryTemps(param).then(res => {
        if (res.success) {
          let data = res.data;
          this.contractInfoList = data.data;
          this.pageModel.total = data.total;
        } else {
          this.$message.error(res.description);
        }
        this.loading = false;
      });
    },
    contractsQuery () {
      this.loading = true;
      this.smartAPI
        .draftTemps(this.tabName === "contracts" ? { contractSource: 2 } : {})
        .then(res => {
          if (res.success) {
            this.contractTypeList = res.data;
            this.contractItem(res.data[0]);
          } else {
            this.$message.error(res.description);
            this.loading = false;
          }
        });
    },
    // 每页条数变化
    handleSizeChange (val) {
      this.pageModel.page = 1;
      this.pageModel.pageSize = val;
      this.searchData();
    },
    // 当前页改变
    handleCurrentChange (val) {
      this.pageModel.page = val;
      this.searchData();
    },
    // 显示购买弹窗
    buyDia () {
      let title = "提示",
        text = "当前无合同起草功能使用次数，请前往购买！";

      this.$confirm(text, title, {
        type: "error"
      })
        .then(res => {
          const url = this.globalConfig.domain.accountWeb + "/asset/aiContractChargePage"
          isInDingTalk ? location.href = url : window.open(url);
        })
        .catch(err => {
          // this.$message.error("err", err);
        });
    }
  },
  components: { RouteName, ElGo },
  created () {
    this.contractsQuery();
  }
};
</script>

<style scoped lang="less">
.root-contrast {
  height: 100%;
  background-color: #fff;
  .content {
    height: calc(85vh - 36px);
    padding: 16px;
    overflow: auto;
    .left {
      height: 66.6vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 10px 10px 10px;
      .left-btn {
        width: 100%;
        height: 46px;
        line-height: 46px;
        display: flex;
        justify-content: center;
        cursor: pointer;
        background: #ffffff;
        margin-bottom: 5px;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid #dddddd;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 600;
        color: #555555;
        &:hover {
          color: #f1461e;
        }
      }
      .left-title {
        width: 100%;
        height: 46px;
        line-height: 46px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 600;
        color: #222222;
        // background: #fdecec;
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        cursor: pointer;
        > div {
          width: 50%;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .active {
          font-size: 16px;
          color: #f1461e;
          background: #fdecec;
        }
      }
      .items {
        width: 100%;
        height: 60vh;
        overflow: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
    .right {
      .doc-list {
        height: 61vh;
        padding: 10px;
        overflow: auto;
        .doc-item {
          padding: 10px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          box-shadow: 0px 0px 12px 1px rgba(0, 0, 0, 0.16);
          border-radius: 4px;
          .doc-item-info {
            display: flex;
            align-items: center;
            width: 95%;
            .info {
              display: flex;
              flex-direction: column;
              justify-content: center;
            }
          }
          .separate {
            display: inline-block;
            height: 60px;
            margin: 0 3px;
            border: 1px solid #d2d2d2;
          }
          .doc-action {
            width: calc(20% - 7px);
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
          img {
            width: 75px;
            height: 75px;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// pages/smartDoc/docDraft/draft.vue